import { gql } from "@apollo/client";

const GET_SPONSORS = gql`
  query GetSponsorListByBrand(
    $input1: PageDto!
    $input2: SortDto!
    $input3: SponsorPlanFilterDto!
  ) {
    GetSponsorListByBrand(
      getSponsorListPageDto: $input1
      getSponsorListSortDto: $input2
      filterDto: $input3
    ) {
      subscribedSponsors {
        _id
        sponsor {
          _id
          email
          name
          profile_picture
          createdAt
          tvl
          payment_gateway
        }
        subscription_end_date
        status
        planDetails {
          _id
          name
        }
      }
      totalCount
    }
  }
`;

const GET_SPONSORS_DETAILS = gql`
  query GetSponsorSubscriptionDetails($input: SponsorSubscriptionDto!) {
    GetSponsorSubscriptionDetails(sponsorSubscriptionDto: $input) {
      _id
      sponsor {
        _id
        email
        name
        profile_picture
        status
        tvl
        device_id
        stripe_customer_id
        createdAt
        payment_gateway
        updatedAt
      }
      subscription_start_date
      subscription_end_date
      status
      planDetails {
        _id
        name
      }
    }
  }
`;

const GET_SPONSORS_PRODUCT_DETAILS = gql`
  query SponsorProducts(
    $input: SponsorSubscriptionDto!
    $input1: PageDto!
    $input2: Filter!
    $input3: SearchDto!
  ) {
    SponsorProducts(
      sponsorSubscriptionDto: $input
      pageDto: $input1
      filterDto: $input2
      searchDto: $input3
    ) {
      products {
        _id
        sponsor
        brand
        product_collection_name
        products
        sponsor_products_count
      }
      totalCount
    }
  }
`;

const GET_SPONSORS_STRIPE_DETAILS = gql`
  query SponsorStripeTransactionList(
    $input1: PageDto!
    $input2: TransactionFilterDto!
  ) {
    SponsorStripeTransactionList(pageDto: $input1, filterDto: $input2) {
      transactions {
        _id
        sponsor
        brand
        plan
        amount_paid
        currency
        payment_status
        subscription_status
        logs {
          paymentIntent
        }
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

const GET_SPONSORS_CRYPTO_DETAILS = gql`
  query SponsorCryptoTransactionList(
    $input1: PageDto!
    $input2: TransactionFilterDto!
  ) {
    SponsorCryptoTransactionList(pageDto: $input1, filterDto: $input2) {
      transactions {
        _id
        sponsor
        brand
        plan
        amount_paid
        currency
        payment_status
        subscription_status
        transaction_hash
        logs
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

const GET_SPONSORS_REVENUE_CAT_DETAILS = gql`
  query SponsorRevenueCatTransactionList(
    $input1: PageDto!
    $input2: TransactionFilterDto!
  ) {
    SponsorRevenueCatTransactionList(pageDto: $input1, filterDto: $input2) {
      transactions {
        _id
        sponsor
        brand
        plan
        amount_paid
        currency
        payment_status
        subscription_status
        revenuecat_transaction_id
        revenuecat_product_id
        revenuecat_customer_id
        revenuecat_store
        logs
        createdAt
        updatedAt
      }
      totalCount
    }
  }
`;

export {
  GET_SPONSORS,
  GET_SPONSORS_DETAILS,
  GET_SPONSORS_PRODUCT_DETAILS,
  GET_SPONSORS_STRIPE_DETAILS,
  GET_SPONSORS_CRYPTO_DETAILS,
  GET_SPONSORS_REVENUE_CAT_DETAILS,
};
